import React, { useState } from "react";
import { Checkbox } from "antd";
import { FilterButtonGroup } from "../filter-button-group";
import filterStyles from "../filter.module.css";
import { MatterStatus } from "~/gql/graphql";
import { CheckboxValueType } from "../checkbox-filter/checkbox-filter";

const {
  ["filter-dropdown"]: filterDropdownClassName,
  ["filter-content"]: filterContentClassName,
  ["checkbox-group"]: checkboxGroupClassName,
} = filterStyles;

export type StatusFilterProps = {
  defaultValue?: string[];
  onApplyFilter: (value: string[]) => void;
  onClearFilter: () => void;
};

export const StatusFilter = ({ defaultValue, onApplyFilter, onClearFilter }: StatusFilterProps) => {
  const [canApply, setCanApply] = useState(false);
  const [value, setValue] = useState(defaultValue || []);

  const onClickApply = () => {
    setCanApply(false);
    onApplyFilter && onApplyFilter(value);
  };

  const onClickClear = () => {
    setValue([]);
    setCanApply(false);
    onClearFilter && onClearFilter();
  };

  const onChange = (newValue: CheckboxValueType[]) => {
    setValue(newValue.map(String));
    setCanApply(true);
  };

  return (
    <div className={filterDropdownClassName}>
      <FilterButtonGroup
        canApply={canApply}
        canClear={value?.length > 0}
        onClickApply={onClickApply}
        onClickClear={onClickClear}
      />
      <div className={filterContentClassName}>
        <Checkbox.Group
          className={checkboxGroupClassName}
          options={[
            { label: "Won", value: "Won" },
            { label: "Lost", value: MatterStatus.Lost },
          ]}
          value={value}
          onChange={onChange}
        />
      </div>
    </div>
  );
};
